import React, { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as viewReducer from "containers/View/reducer";
import styles from "./style.module.css";
import { getToolMeta } from "./ToolCallDisplay";
const AddModelFeedback = ({ message, executionId, onRetryWithFeedback, isCommenting, updateIsCommenting }) => {
    const dispatch = useDispatch();
    const [pendingComment, updatePendingComment] = useState("");
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const isNextSaving = useSelector((state) => nextReducer.getIsSavingReport(state, nextId));
    const disableFeedback = isAsking || isNextSaving;
    const chatType = useSelector(chatGPTReducer.getChatType);
    const blueprintId = useSelector(chatGPTReducer.getBlueprintId);
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const userPrompt = useSelector((state) => chatGPTReducer.getPrompt(state));
    const questionIndex = dispatch(chatGPTReducer.getQuestionIndexFromMessage(message));
    const question = useSelector((state) => chatGPTReducer.getConversationMessage(state, questionIndex ?? 0));
    const userMPrompt = question?.isQuestion ? question.userPrompt : undefined;
    const retryPrompt = userMPrompt ?? question?.userPrompt ?? question?.text ?? userPrompt;
    const userPromptAugment = pendingComment ? "\n\nHint:\n" + pendingComment : undefined;
    const hintsArray = [pendingComment];
    const isTemplate = location.pathname.indexOf("chatTemplate") !== -1;
    const agentSimpleAnalyticsView = useSelector((state) => viewReducer.getAgentSimpleAnalyticsView(state));
    const useAgentSimpleAnalytics = agentSimpleAnalyticsView;
    const isAnalyticsChat = chatType === "AIBLE" || chatType === "WHATS_CHANGED";
    const isSimpleAgentAnalytics = useAgentSimpleAnalytics && isAnalyticsChat;
    const toolCallsFeedback = useSelector((state) => chatGPTReducer.getToolCallsFeedbackByQuestion(state, questionIndex));
    return (React.createElement(React.Fragment, null, isCommenting && (React.createElement("div", { className: styles.reasonFeedbackComment },
        React.createElement("div", { style: { fontWeight: "bold" } }, "What did I do wrong?"),
        React.createElement(LineInput, { style: { marginBottom: "10px", background: "white" }, value: pendingComment, isDisabled: disableFeedback, onChange: updatePendingComment }),
        questionIndex !== undefined &&
            Object.keys(toolCallsFeedback ?? {}).map((cToolName) => {
                const cFeedback = toolCallsFeedback?.[cToolName];
                const { label, icon } = getToolMeta(cToolName);
                return (React.createElement("div", { className: styles.toolFeedbackItem },
                    React.createElement("div", { className: styles.toolFeedbackName }, label),
                    React.createElement("div", { className: styles.toolFeedbackInput },
                        React.createElement(LineInput, { style: { background: "white" }, value: cFeedback, isDisabled: disableFeedback, onChange: (val) => {
                                dispatch(chatGPTReducer.updateToolCallsFeedbackByQuestionAndTool(questionIndex, cToolName, val));
                            } })),
                    React.createElement("div", { className: styles.toolFeedbackAction },
                        React.createElement(Button, { type: "secondary", isSmall: true, onClick: () => {
                                dispatch(chatGPTReducer.updateToolCallsFeedbackByQuestionAndTool(questionIndex, cToolName, undefined));
                            } }, "Delete"))));
            }),
        React.createElement("div", { className: styles.reasonFeedbackActions },
            React.createElement(Button, { type: "primary", style: { marginRight: "10px" }, disabled: disableFeedback, onClick: () => {
                    if (blueprintId === "AGENT_IQ" || blueprintId === "AGENT_IQ_TEAM") {
                        const retUserPrompt = userPrompt === undefined || userPrompt === null || userPrompt === "" ? question?.text : userPrompt;
                        dispatch(chatGPTReducer.handleAgentIQ(retUserPrompt + "\n\nHint:\n" + pendingComment, false, blueprintId === "AGENT_IQ_TEAM" ? "reasoning-team" : "reasoning"));
                    }
                    else if (onRetryWithFeedback !== undefined) {
                        onRetryWithFeedback(pendingComment);
                    }
                    else {
                        dispatch(chatGPTReducer.handleAskGPT(retryPrompt, undefined, undefined, undefined, undefined, Boolean(!retryPrompt), userPromptAugment, true, executionId, hintsArray, userPromptAugment, userPromptAugment, undefined, isSimpleAgentAnalytics, toolCallsFeedback));
                    }
                    updateIsCommenting(false);
                } }, "Retry and Improve Model"),
            React.createElement(Button, { disabled: disableFeedback, onClick: () => {
                    updatePendingComment("");
                    updateIsCommenting(false);
                } }, "Cancel"))))));
};
export default AddModelFeedback;
